/**
 * Locates which cache chunk an absolute event index falls in. Divides the index by the chunk size and floors the result.
 *
 * @param startIndex - absolute index of the event.
 * @param chunkSize - how many events one chunk holds.
 * @returns The zero-based chunk index.
 */
export const getCurrentChunk = (startIndex: number, chunkSize: number) =>
  Math.floor(startIndex / chunkSize);

/**
 * Cuts one page of strips out of the chunked holter-event cache. Reads the page's own chunk, appends the following one when the page straddles a chunk boundary, and slices the requested range using indices rebased onto that chunk's start.
 *
 * @param data - the cached events keyed by chunk name.
 * @param startIndex - absolute index of the page's first event.
 * @param endIndex - absolute index just past the page's last event.
 * @param currnetChunk - index of the chunk the page starts in.
 * @param chunkSize - how many events one chunk holds.
 * @returns The events covering the requested page.
 */
export const getCachedDataSlice = (
  data: any,
  startIndex: number,
  endIndex: number,
  currnetChunk: number,
  chunkSize: number,
) => {
  let events = data?.[`chunk-${currnetChunk}`] || [];
  const sliceChunkIdx = currnetChunk * chunkSize;
  const chunks = Math.floor(endIndex / chunkSize) - Math.floor(startIndex / chunkSize);
  if (chunks > 0) {
    const nextChunk = data?.[`chunk-${currnetChunk + 1}`] || [];
    events = [...events, ...nextChunk];
  }
  return events.slice(startIndex - sliceChunkIdx, endIndex - sliceChunkIdx);
};
